import React from 'react';

const FloatingCTA = () => {
  const handleMessagingClick = (platform) => {
    try {
      if (window.gtag) {
        window.gtag('event', 'messaging_click', { label: platform });
      }
    } catch (e) { }
  };

  return (
    <div className="floatICONABS">
      {/* <a href="https://t.me/upgrace_in  " className="float-btn" aria-label="Contact Upgrace" onClick={() => handleCTAClick('Floating Contact')}>
        <i className="far fa-paper-plane"></i>
      </a> */}
      <a
        href="https://calendly.com/upgrace-in/30min"
        className="float-btn calendly"
        target="_blank"
        rel="noreferrer"
        aria-label="Schedule Meeting"
        onClick={() => handleMessagingClick('Calendly')}
      >
        <i className="fas fa-calendar-alt"></i>
      </a>
      <a
        href="https://wa.me/918210868642"
        className="float-btn whatsapp"
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        onClick={() => handleMessagingClick('WhatsApp')}
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default FloatingCTA; 